import React from "react";
import { StepComponentProps } from "./types";
import StepList from "./StepList";
import PromoBanner from "@/components/PromoBanner";
import { DEFAULT_THEME } from "./constants";
import useTranslations from "@/i18n/useTranslations";

const bgClassMap = {
  light: "bg-putty-100",
  dark: "bg-putty-300",
};

function StepComponent({
  title,
  steps,
  promo,
  theme = DEFAULT_THEME,
  className,
  programIsEnrollable = false,
}: StepComponentProps) {
  const t = useTranslations("StepComponent");
  const resolvedTitle = title ?? t("startLearningIn3Steps");
  const resolvedSteps = steps ?? [
    {
      title: t("createAccountTitle"),
      description: t("createAccountDescription"),
    },
    {
      title: t("enrollInCourseTitle"),
      description: t("enrollInCourseDescription"),
    },
    {
      title: t("startLearningTitle"),
      description: t("startLearningDescription"),
    },
  ];

  return (
    <div
      className={`fullwidth pb-6 md:pb-16 max-w-none ${bgClassMap[theme]} ${className || ""}`}
    >
      <div className="container">
        <div className="flex flex-col gap-[24px] md:gap-16">
          {theme === "light" && <div className="border-t border-putty-400" />}
          <div className="gap-[21px] flex flex-col">
            {resolvedTitle && (
              <h2 className="font-bold text-xl md:text-2xl text-[#073133] dark:text-white mt-0 mb-0">
                {resolvedTitle}
              </h2>
            )}
            <StepList steps={resolvedSteps} theme={theme} />
          </div>
          {programIsEnrollable && promo && (
            <PromoBanner
              variant="compactPDP"
              {...{
                ctaElement: promo.ctaElement,
                compact: {
                  headline: promo.headline || t("promoHeadline"),
                  subtext: promo.subtext || t("promoSubtext"),
                  infoText: promo.infoText || t("promoInfoText"),
                  headlineMobile:
                    promo.headlineMobile ||
                    promo.headline ||
                    t("promoHeadline"),
                  subtextMobile:
                    promo.subtextMobile || promo.subtext || t("promoSubtext"),
                },
              }}
            />
          )}
          {theme === "light" && <div className="border-t border-putty-400" />}
        </div>
      </div>
    </div>
  );
}

export default StepComponent;
